import { Anexo } from "./types";
import { formatFileSize } from "../../../../../../utility/byteSizeUtils";
import { parseJsonSafely } from "../../../../../../utility/jsonUtils";
import { extractFilename } from "../../../../../../utility/filePathUtils";

export const mapearAnexos = (logs: any[]): Anexo[] => {
    const anexos: Anexo[] = [];
    
    // Filtrar logs de arquivos tanto de proposta quanto de orientação completa
    const logsAnexos = logs.filter((log: any) => 
        log.entidade_nome === 'proposta_arquivo' || log.entidade_nome === 'orientacao_arquivo'
    );
    
    for (const log of logsAnexos) {
        const dadosDepois = parseJsonSafely(log.dados_depois);
        const dadosAntes = parseJsonSafely(log.dados_antes);
        const dadosExtra = parseJsonSafely(log.dados_extra);
        
        const dadosDepoisObjeto = dadosDepois && typeof dadosDepois === 'object' ? dadosDepois : null;
        const isExclusao = (dadosDepoisObjeto && dadosDepoisObjeto.excluido === true) || (!dadosDepois && dadosAntes);
        
        if (isExclusao) {
            const caminho = dadosAntes?.caminho 
                || dadosDepois?.caminho 
                || dadosExtra?.caminho 
                || dadosAntes?.arquivo_final 
                || dadosDepois?.arquivo_final;
            const filename = extractFilename(caminho);
            const tamanhoArquivo = dadosExtra?.tamanho || dadosAntes?.tamanho || dadosDepois?.tamanho;
            const size = formatFileSize(tamanhoArquivo);
            
            if (caminho && filename && filename !== '—') {
                const dataExclusao = log.criado;
                
                anexos.push({
                    id: log.entidade_id,
                    filename,
                    size: size !== '—' ? size : '—',
                    excluido: true,
                    excluidoPor: 'Operador',
                    excluidoEm: dataExclusao,
                    nomeOriginal: filename
                });
            }
        } else if (dadosDepois) {
            const caminho = dadosDepois.caminho 
                || dadosDepois.arquivo_final 
                || dadosExtra?.caminho 
                || dadosAntes?.caminho 
                || dadosAntes?.arquivo_final;
            const filename = extractFilename(caminho) || dadosDepois.nome_arquivo || dadosExtra?.nome_arquivo;
            const tamanhoArquivo = dadosExtra?.tamanho || dadosDepois.tamanho || dadosAntes?.tamanho;
            const size = formatFileSize(tamanhoArquivo);
            const excluidoAtual = dadosDepois.excluido === true || dadosDepois.excluido === 1;

            if (caminho && filename && filename !== '—') {
                anexos.push({
                    id: log.entidade_id,
                    filename,
                    size: size !== '—' ? size : '—',
                    excluido: excluidoAtual
                });
            }
        }
    }
    
    return anexos;
};

